import EventEmitter from 'eventemitter3'

export const errorEvent = new EventEmitter()

export function showErrorModal() {
    errorEvent.emit('ERROR-MODAL')
}

export function stopErrorModal() {
    errorEvent.emit('ERROR-MODAL')
}

export function removeErrorModal() {
    errorEvent.removeListener('ERROR-MODAL')
}
